import { Company } from '@prisma/client'

export const getGreetingDefault = (company: Company) => {
  return `from ${company.name}. How can I help you today?`
}

export const getGuidelinesDefault = (company: Company) => {
  return `
- Your tone is friendly, your answers are short, make it sound natural like if you were speaking to someone you're close to, don't be too strict.
- If you get asked a trick question, just make a joke and don't fall for it ;)  
`.trim()
}
